import { render, staticRenderFns } from "./ProjPackage.vue?vue&type=template&id=3b2e16ae&"
import script from "./ProjPackage.vue?vue&type=script&lang=js&"
export * from "./ProjPackage.vue?vue&type=script&lang=js&"
import style0 from "./ProjPackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports